// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V10H2V2ZM8 4.99805H5.99609V7.00195H7.99609V6.99805H8V4.99805ZM18 4.99805H10V6.99805H18V4.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 12H22V22H2V12Z"}}]};

const MenuFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'menu-filled',
    ref,
    icon: element,
  },
));

MenuFilledIcon.displayName = 'MenuFilledIcon';

export default MenuFilledIcon;
